import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { labelClassName, assertLabelProps } from '../label.utils';
import type { BaseLabelProps } from '../label.utils';
import { sprinkles } from '@/css/sprinkles.css';
import clsx from 'clsx';
import { extractProps } from '@/utils/vanilla-extract-props';
import PlumaBox from '../../box/ember/index';
import type { BoxSignature } from '../../box/ember/index';
import StatusIndicator from './-private/status-indicator.gts';
export interface LabelSignature<T extends string = 'span'> {
    Element: BoxSignature<T>['Element'];
    Args: BoxSignature<T>['Args'] & BaseLabelProps;
    Blocks: {
        default: [];
    };
}
export default class Label<T extends string = 'button'> extends Component<LabelSignature<T>> {
    constructor(owner1: unknown, args1: LabelSignature<T>['Args']){
        super(owner1, args1);
        assertLabelProps(args1);
    }
    get as() {
        return (this.args.as ?? 'span') as any;
    }
    get className() {
        const { color: color1, bold: bold1, showStatusIndicator: showStatusIndicator1, ...restArgs1 } = this.args;
        // Until something like https://github.com/emberjs/rfcs/pull/593 lands in
        // Ember, we can't forward arbitrary args to the PlumaBox component.
        // Instead, we need to extract sprinkle arguments and get the class names in
        // each Ember component.
        const { sprinkleProps: sprinkleProps1 } = extractProps(restArgs1);
        return clsx(labelClassName({
            color: color1,
            bold: bold1,
            showStatusIndicator: showStatusIndicator1
        } as Partial<BaseLabelProps>), sprinkles(sprinkleProps1));
    }
    // prettier-ignore
    static{
        template(`<PlumaBox
		@as={{this.as}}
		class={{this.className}}
		{{! @glint-expect-error }}
		...attributes
		>
			{{~#if @showStatusIndicator~}}
				<StatusIndicator @color={{@color}} />
			{{~/if~}}
			{{~yield~}}
		</PlumaBox>`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
